module.exports = __webpack_public_path__ + "static/media/speaker_body_point_right.e87f49bd.png";